import React, { useState, useEffect } from "react";
import { renameDatabase } from "../../../../../../../../../api/database_gui.js";
import RenameItemPopup from "../RenameItemPopup.js";
import { Tooltip } from "@mui/material";

const RenameDatabasePopup = ({
  visible,
  onClose,
  onSave,
  currentName,
  setNewName,
  systemUserId,
  resourceId,
  databaseInfo,
}) => {
  const [newName, setNewNameLocal] = useState(currentName);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setNewNameLocal(currentName);
  }, [currentName]);

  const handleSave = (newName) => {
    onSave(newName);
  };

  const renameDatabaseFunction = async (newName) => {
    const response = await renameDatabase(
      resourceId,
      systemUserId,
      currentName,
      newName
    );
    return response;
  };

  return (
    <RenameItemPopup
      visible={visible}
      onClose={onClose}
      onSave={handleSave}
      currentName={currentName}
      newName={newName}
      setNewName={setNewNameLocal}
      loading={loading}
      setLoading={setLoading}
      renameFunction={renameDatabaseFunction}
      successMessage="Database renamed successfully!"
      errorMessage="Error while renaming database."
      itemType="Database"
      databaseInfo={databaseInfo}
    />
  );
};

export default RenameDatabasePopup;
